// Centralized NAP (Name, Address, Phone) data for SEO consistency
// Update this file to change business info across all pages

export const BUSINESS_INFO = {
  name: "All Time Paint & Plaster Co.",
  phone: "(201) 701-8248",
  phoneLink: "tel:+12017018248",
  email: "info@alltimepaintandplaster.com",
  emailLink: "mailto:info@alltimepaintandplaster.com",
  website: "https://alltimepaintandplaster.com",
  
  // NJ Home Improvement Contractor License
  license: {
    number: "13VH10434100",
    type: "NJ Home Improvement Contractor",
    fullText: "NJ HIC License #13VH10434100",
    shortText: "NJ Lic. #13VH10434100",
    issuedBy: "New Jersey Division of Consumer Affairs",
  },
  
  // Primary location
  address: {
    street: "1581 Route 23 South, Suite 1",
    city: "Wayne",
    state: "NJ",
    stateFullName: "New Jersey",
    zip: "07470",
    country: "US",
  },
  addressText: "1581 Route 23 South, Suite 1, Wayne, NJ 07470",
  
  // Service areas
  serviceAreas: [
    "Bergen County",
    "Passaic County", 
    "Morris County",
    "Essex County",
    "Hudson County",
  ],
  serviceAreasText: "Bergen, Passaic, Morris, Essex & Hudson Counties, NJ",

  
  // Geo coordinates (Wayne, NJ)
  geo: {
    latitude: "40.9251",
    longitude: "-74.2765",
  },
  
  // Business hours — Mon-Sun 8 AM - 8 PM
  hours: {
    weekdays: "8:00 AM - 8:00 PM",
    saturday: "8:00 AM - 8:00 PM",
    sunday: "8:00 AM - 8:00 PM",
  },
  
  // Social media
  social: {
    facebook: "https://www.facebook.com/alltimepainters",
    instagram: "https://www.instagram.com/alltimepainters",
    tiktok: "https://www.tiktok.com/@alltimepainters",
    youtube: "https://www.youtube.com/channel/UCgR-g5wRfRJD6fgvVktInkw",
  },
  
  // Business info
  priceRange: "$$",
  
} as const;

/** One factual description reused by the sitewide business structured data. */
export const BUSINESS_DESCRIPTION =
  "All Time Paint & Plaster Co. is a Wayne, New Jersey painting and decorative finish contractor providing interior and exterior painting, Venetian and lime plaster, limewash, microcement and specialty finishes for residential and commercial clients throughout North Jersey.";

/** Stable public URL of the official company logo (used in structured data). */
export const LOGO_URL =
  "https://alltimepaintandplaster.com/__l5e/assets-v1/b80b57f9-bb35-4c5d-8843-98bf63cecbcc/atp-logo-dark.webp";

// SMS (text) estimate request — works on both iOS and Android
export const SMS_NUMBER = "+12017018248";
export const SMS_MESSAGE =
  "Hi All Time Paint & Plaster Co., I’d like an estimate. My name is ____. My project is located in ____. I need help with ____. I’ll attach photos below.";
export const SMS_LINK = `sms:${SMS_NUMBER}?&body=${encodeURIComponent(SMS_MESSAGE)}`;

// Helper to get formatted address for a specific town
export const getLocalAddress = (townName: string) => ({
  ...BUSINESS_INFO.address,
  city: townName,
});

// Helper to get full NAP string
export const getNAPString = (townName?: string) => {
  const city = townName || BUSINESS_INFO.address.city;
  return `${BUSINESS_INFO.name} | ${BUSINESS_INFO.phone} | ${city}, ${BUSINESS_INFO.address.state}`;
};
